import { FormattedMessage } from 'react-intl';

import {
  CHECKINGS_ACCOUNT_TYPE,
  SAVINGS_ACCOUNT_TYPE,
} from './accountTypes.constants';
import moment from 'moment';
import {
  FIELD_AMOUNT,
  FIELD_DATE_PAST,
  FIELD_GROUP_BUTTONS,
  FIELD_INTEREST_RATE,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  COMMON_FIELD_NAMES,
} from './constants.fields';

export const MSG_CHECKINGS = 'afforda.assets.details.checkings';

const SOURCE_OPTIONS = {
  CHECKINGS: {
    value: CHECKINGS_ACCOUNT_TYPE,
    text: <FormattedMessage id="afforda.assets.details.checkings" />,
  },
  SAVINGS: {
    value: SAVINGS_ACCOUNT_TYPE,
    text: <FormattedMessage id="afforda.assets.details.savings" />,
  },
};

export const CHECKING_FIELD_NAMES = {
  memberId: COMMON_FIELD_NAMES.memberId,
  type: 'type',
  amount: COMMON_FIELD_NAMES.amount,
  interestRate: COMMON_FIELD_NAMES.interestRate,
  averageBalance: 'averageBalance',
  dateOpened: 'dateOpened',
};

export const FIELDS = ({ intl, members, disabledMembers, hasAdoptedHOTMA }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_GROUP_BUTTONS,
      name: CHECKING_FIELD_NAMES.type,
      label: (
        <FormattedMessage id="afforda.assets.details.checkings.accountType" />
      ),
      variant: 'buttonGroup',
      rules: {
        required: true,
      },
      direction: { xs: 'column', sm: 'row' },
      hidden: ({ getValues }) =>
        !getValues(CHECKING_FIELD_NAMES.memberId)?.length,
      watchFields: [CHECKING_FIELD_NAMES.memberId],
      options: Object.values(SOURCE_OPTIONS)?.map((option) => ({
        value: option.value,
        label: option.text,
      })),
    },
    // Amount
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      hidden: ({ getValues }) =>
        getValues(CHECKING_FIELD_NAMES.type).length === 0,
      GridProps: {
        xs: 12,
        sm: 6,
      },
      label: (
        <FormattedMessage
          id={
            hasAdoptedHOTMA
              ? 'afforda.assets.details.checkings.currentBalance'
              : 'afforda.assets.details.checkings.currentAmount'
          }
        />
      ),
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.amount',
      }),
      name: CHECKING_FIELD_NAMES.amount,
    },
    // Interest Rate
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_INTEREST_RATE,
      hidden: ({ getValues }) =>
        getValues(CHECKING_FIELD_NAMES.type).length === 0,
      GridProps: {
        xs: 12,
        sm: 6,
      },
      name: CHECKING_FIELD_NAMES.interestRate,
      label: <FormattedMessage id="afforda.assets.details.interestRate" />,
      helperText: <FormattedMessage id="afforda.assets.details.ifAplicable" />,
    },
    // Average Balance Over the Last 6 Months (Checkings)
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,

      GridProps: {
        xs: 12,
        sm: 6,
      },
      hidden: ({ getValues }) =>
        getValues(CHECKING_FIELD_NAMES.type) !== CHECKINGS_ACCOUNT_TYPE ||
        hasAdoptedHOTMA,
      name: CHECKING_FIELD_NAMES.averageBalance,
      label: (
        <FormattedMessage id="afforda.assets.details.checkings.averageBalance" />
      ),
    },
    // Date Opened
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_DATE_PAST,
      rules: {
        required: false,
        maxDate: moment().startOf('day'),
      },
      GridProps: {
        xs: 12,
        sm: 6,
      },
      hidden: ({ getValues }) =>
        getValues(CHECKING_FIELD_NAMES.type)?.length === 0,
      name: CHECKING_FIELD_NAMES.dateOpened,
      label: (
        <FormattedMessage id="afforda.assets.details.checkings.dateOpened" />
      ),
    },
  ];
};
